import {
  LOAD_RETURN_POLICIES,
  RETURN_POLICIES_LOADED,
  SYNC_FAILED,
  RESET_RETURN_POLICIES,
  RESET_RETURN_POLICY,
  RETURN_POLICY_DELETED,
  LOAD_RETURN_POLICY,
  RETURN_POLICY_LOADED,
  SAVE_RETURN_POLICY,
  RETURN_POLICIES_SAVED,
  SYNCING,
  RESET_ERROR,
  RETURN_POLICIES_POPUP,
} from './actionTypes';
import { IReturnPolicy } from './types';

export const initialState = {
  error: null,
  returnPoliciesLoaded: false,
  returnPolicies: [] as IReturnPolicy[],
  returnPolicy: null,
  returnPoliciesSaved: false,
  popupOpen: false,
  syncing: false,
};

export const reducer = (state = initialState, action: { type: string; payload?: any }) => {
  switch (action.type) {
    case LOAD_RETURN_POLICIES:
      return { ...state, syncing: true };
    case RETURN_POLICIES_LOADED:
      return {
        ...state,
        returnPolicies: action.payload,
        syncing: false,
        returnPoliciesLoaded: true,
        returnPoliciesSaved: false,
      };
    case LOAD_RETURN_POLICY:
      return { ...state,  syncing: true };
    case RETURN_POLICY_LOADED:
      return {
        ...state,
        returnPolicy: action.payload,
        syncing: false,
        returnPoliciesSaved: false,
      };
    case RESET_RETURN_POLICIES:
      return initialState;
    case RESET_RETURN_POLICY:
      return { ...state, returnPolicy: null, syncing: false };
    case RETURN_POLICY_DELETED:
      const newReturnPolicies = state.returnPolicies.filter((item: IReturnPolicy) => {
        return item.id !== action.payload;
      });
      return { ...state, returnPolicies: newReturnPolicies, syncing: false };
    case SAVE_RETURN_POLICY:
      return {
        ...state,
        returnPoliciesSaved: false,
        syncing: true,
      };
    case RETURN_POLICIES_SAVED:
      return {
        ...state,
        returnPoliciesSaved: !state.returnPoliciesSaved,
        syncing: false,
      };
    case RETURN_POLICIES_POPUP:
      return { ...state, popupOpen: action.payload };
    case SYNC_FAILED:
      return { ...state, syncing: false, error: action.payload };
    case SYNCING:
      return { ...state, syncing: true };
    case RESET_ERROR:
      return { ...state, error: null };
    default:
      return state;
  }
};
